import { colors } from "@areahub/theme/src/foundations";
import { Feature, Geometry } from "@turf/turf";
import { DynamicLegendProps } from "@ui/maps/common";
import { subscriberLayerMap } from "@ui/maps/interactive-map/src/helpers/subscriber-layers";
const defaultLegendRows: DynamicLegendProps["legendRows"] = [
  {
    icon: "circle",
    color: "blue.300",
    label: "Queried Radius",
  },
];
export function getHazardMapLegend(
  displayName: string,
  feature?: Feature<Geometry, any>,
  category?: string,
  color?: string,
) {
  if (category) {
    const def = subscriberLayerMap.get(category);

    if (def) {
      return [
        {
          label: displayName,
          color: def?.iconColor ?? color ?? colors.blue[800],
          icon:
            def.layer.type === "fill"
              ? "draw-polygon"
              : def.layer.type === "line"
              ? "draw-line"
              : def.layer.type === "symbol"
              ? (def.layer?.layout?.["icon-image"] as string)
              : "circle",
        },
      ];
    }
  }
  switch (feature?.geometry?.type) {
    case "Point":
      return [
        ...defaultLegendRows,
        {
          icon: "circle",
          color: color || "blue.800",
          label: displayName,
        },
      ];
    case "LineString":
      return [
        ...defaultLegendRows,
        {
          icon: "line-string",
          color: color || "blue.800",
          label: displayName,
        },
      ];
    case "MultiLineString":
      return [
        ...defaultLegendRows,
        {
          icon: "line-string",
          color: color || "blue.800",
          label: displayName,
        },
      ];
    default:
      return [
        ...defaultLegendRows,
        {
          icon: "circle",
          color: color || "blue.800",
          label: displayName,
        },
      ];
  }
}
